import { GlLineChart } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/charts.js?vue3';
import { merge } from 'lodash-es';
import dateFormat from '~/lib/dateformat';
import { __, n__, s__, sprintf } from '~/locale';
import commonChartOptions from './common_chart_options';
export default {
    name: 'BurndownChart',
    components: {
        GlLineChart
    },
    props: {
        startDate: {
            type: String,
            required: true
        },
        dueDate: {
            type: String,
            required: true
        },
        openIssuesCount: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        openIssuesWeight: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        issuesSelected: {
            type: Boolean,
            required: false,
            default: true
        },
        showTitle: {
            type: Boolean,
            required: false,
            default: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            tooltip: {
                title: '',
                content: ''
            }
        };
    },
    computed: {
        dataSeries () {
            const name = s__('BurndownChartLabel|Remaining');
            let data;
            if (this.issuesSelected) {
                data = this.openIssuesCount;
            } else {
                data = this.openIssuesWeight;
            }
            const series = [
                {
                    name,
                    data
                }
            ];
            if (data.length > 0) {
                const zeroStart = [
                    this.startDate,
                    0
                ];
                const firstNonZero = data.find((dataObj)=>dataObj[1] !== 0) || zeroStart;
                const idealStart = [
                    this.startDate,
                    firstNonZero[1]
                ];
                const idealEnd = [
                    this.dueDate,
                    0
                ];
                const idealData = [
                    idealStart,
                    idealEnd
                ];
                series.push({
                    name: __('Guideline'),
                    data: idealData,
                    silent: true,
                    symbolSize: 0,
                    lineStyle: {
                        color: '#ddd',
                        type: 'dashed'
                    }
                });
            }
            return series;
        },
        yAxisTitle () {
            return __('Work items');
        },
        options () {
            return merge({}, commonChartOptions, {
                xAxis: {
                    min: this.startDate,
                    max: this.dueDate
                },
                yAxis: {
                    name: this.issuesSelected ? this.yAxisTitle : __('Weight')
                }
            });
        }
    },
    methods: {
        setChart (chart) {
            this.chart = chart;
        },
        formatTooltipText (params) {
            const [seriesData] = params.seriesData;
            if (!seriesData) {
                return;
            }
            this.tooltip.title = dateFormat(params.value, 'dd mmm yyyy');
            if (this.issuesSelected) {
                this.tooltip.content = n__('%d remaining', '%d remaining', seriesData.value[1]);
            } else {
                this.tooltip.content = sprintf(__('%{total} remaining weight'), {
                    total: seriesData.value[1]
                });
            }
        }
    }
};
